/**
 * How often the calendar re-fetches itself, in ms.
 *
 * Two queries feed the same screens — `useSchedule` (appointments, absences, breaks) and
 * `useTechnicianTasks` — and `entities/schedule/model/dataFreshness.ts` expresses its "this is old"
 * thresholds as counts of missed polls. Three files, one number: it lives here rather than in either
 * entity because `entities/task` may not import from `entities/schedule`, and a literal repeated in
 * three places is a literal that will eventually disagree with itself.
 */
export const SCHEDULE_POLL_MS = 60_000
